import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/groups/pages/publicGroupsPage.tsx");
